<template>
<div class="vliveContent">
    <div class="flex">
        <div class="theme-color">
            <span class="title">主题色</span>
            <el-color-picker v-model="contentthemecolor"></el-color-picker>
        </div>
        <el-button type="primary" @click="submitVliveContent">保存</el-button>
    </div>
    <div class="content-box">
        <el-tabs v-model="activeNameTab" addable @edit="handleTabsEdit">
            <el-tab-pane :key="index" v-for="(item, index) in list" :name="index+''">
                <span slot="label">
                    <el-dropdown>
                        <span class="el-dropdown-link" @click="clickLinkurl(item)">
                            {{item.columnname}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  @click.native="handleVliveContentEdit(item)">重命名</el-dropdown-item>
                            <el-dropdown-item  @click.native="handleVliveContentDel(item)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
                <!--图文-->
                <uEditor :content="imgText.content" ref="uEditor" @getUEditorContent="getUEditorContent" v-if="item.columntype==1"></uEditor>
                <vliveContentVideos ref="vliveContentVideos" v-if="item.columntype==2"></vliveContentVideos>
                <vliveContentImages ref="vliveContentImages" v-if="item.columntype==3"></vliveContentImages>
                <vliveContentVliveImageText ref="vliveContentVliveImageText" v-if="item.columntype==4"></vliveContentVliveImageText>
                <vliveContentComment ref="vliveContentComment" v-if="item.columntype==5"></vliveContentComment>
            </el-tab-pane>
        </el-tabs>
    </div>
    <vliveContentEdit ref="vliveContentEdit" @getVliveContentList="_getVliveContentList"></vliveContentEdit>
</div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor'
import {mapGetters, mapActions} from 'vuex'
import VliveContentEdit from 'views/cms/vlive/components/vliveContentComponents/vliveContentEdit'
import VliveContentImages from 'views/cms/vlive/components/vliveContentComponents/vliveContentImages'
import VliveContentVideos from 'views/cms/vlive/components/vliveContentComponents/vliveContentVideos'
import VliveContentVliveImageText from 'views/cms/vlive/components/vliveContentComponents/vliveContentVliveImageText'
import VliveContentComment from 'views/cms/vlive/components/vliveContentComponents/vliveContentComment'
import {editVliveThemeColor, getVliveContentList, delVliveContent, editVliveContentImgText} from 'api/api'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveContent',
    data() {
        return {
            activeNameTab: '0',
            contentthemecolor: '',
            columntype: [], // 已添加的内容类型
            imgText: {
                innerid: '',
                content: ''
            },
            imageList: [],
            videoList: [],
            list: []
        }
    },
    mounted() {
        this._getVliveContentList()
    },
    methods: {
        clickLinkurl(item) {
            if (item.columntype === 99) {
                window.open(item.linkurl)
            }
        },
        submitVliveContent() {
            this.$confirm(vliveMsg.submitVliveContent.msg, vliveMsg.submitVliveContent.title, {
                confirmButtonText: vliveMsg.submitVliveContent.confirmText,
                cancelButtonText: vliveMsg.submitVliveContent.cancelText
            }).then(() => {
                this._editVliveContent()
            })
        },
        handleVliveContentEdit(obj) {
            this.$refs.vliveContentEdit.openDialog(obj, this.columntype)
        },
        handleVliveContentDel(row) {
            this.$confirm(vliveMsg.delVliveContent.msg, vliveMsg.delVliveContent.title, {
                confirmButtonText: vliveMsg.delVliveContent.confirmText,
                cancelButtonText: vliveMsg.delVliveContent.cancelText
            }).then(() => {
                this._delVliveContent(row)
            })
        },
        getUEditorContent(content) {
            this.imgText.content = content
        },
        handleTabsEdit(targetName, action) {
            if (action === 'add') {
                if (this.list.length < 4) {
                    this.$refs.vliveContentEdit.openDialog('add', this.columntype)
                } else {
                    this.$alert('最多添加4个分类！', '提示', {
                        dangerouslyUseHTMLString: true
                    })
                }
                // let newTabName = ++this.tabIndex + ''
                // this.list.push({
                //     title: 'New Tab',
                //     name: newTabName,
                //     content: 'New Tab content'
                // })
                // this.activeNameTab = newTabName
            }
            if (action === 'remove') {
                let tabs = this.list
                let activeName = this.activeNameTab
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1]
                            if (nextTab) {
                                activeName = nextTab.name
                            }
                        }
                    })
                }

                this.activeNameTab = activeName
                this.list = tabs.filter(tab => tab.name !== targetName)
            }
        },
        _delVliveContent(row) {
            this.setLoading(true)
            delVliveContent({
                data: {
                    innerid: row.innerid,
                    status: 0 // 0无效 1有效
                },
                success: data => {
                    this.setLoading(false)
                    this._getVliveContentList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editVliveContent() {
            this.setLoading(true)
            editVliveThemeColor({
                data: Object.assign({}, {contentthemecolor: this.contentthemecolor}, {assetinnerid: this.vliveModel.assetinnerid}),
                success: data => {
                    console.log(this.columntype)
                    if (this.columntype.indexOf(1) > -1) {
                        editVliveContentImgText({
                            data: Object.assign({}, this.imgText),
                            success: data => {
                                this.$message.success('保存主题色和图文成功！')
                                this.setLoading(false)
                                this._getVliveContentList()
                            },
                            error: data => {
                                this.setLoading(false)
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$message.success('保存主题色成功！')
                        this.setVliveModelThemeColor(this.contentthemecolor)
                        this.setLoading(false)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取内容列表
        _getVliveContentList() {
            this.setLoading(true)
            getVliveContentList({
                data: {assetinnerid: this.$route.query.id ? this.$route.query.id : ''},
                success: data => {
                    this.columntype = []
                    this.list = data.data.content
                    // this.activeNameTab = this.list.length ? (this.list[0].columntype !== 99 ? '0' : '1') : ''
                    if (this.list.length) {
                        if (this.list[0].columntype !== 99) {
                            this.activeNameTab = '0'
                        } else if (this.list.length > 1) {
                            this.activeNameTab = '1'
                        } else if (this.list.length === 1) {
                            this.activeNameTab = ''
                        }
                    }
                    let _this = this
                    this.list.forEach(obj => {
                        switch (obj.columntype) {
                        case 1 : // 图文
                            if (obj.columntype === 1) {
                                this.imgText.innerid = obj.innerid
                                this.imgText.content = obj.content
                                this.$nextTick(() => {
                                    _this.$refs.uEditor[0].init(_this.imgText.content)
                                })
                            }
                            break
                        case 2: // 视频
                            this.$nextTick(() => {
                                _this.$refs.vliveContentVideos[0]._getGroupVideo(obj.relinnerid)
                            })
                            break
                        case 3: // 相册
                            this.$nextTick(() => {
                                _this.$refs.vliveContentImages[0]._getGroupImage(obj.relinnerid)
                            })
                            break
                        case 4: // 图文直播
                            this.$nextTick(() => {
                                _this.$refs.vliveContentVliveImageText[0]._getGroupVliveImageText(obj.relinnerid)
                            })
                            break
                        case 5: // 评论
                            break
                        }
                        this.columntype.push(obj.columntype)
                    })
                    this.setVliveModelContentList(this.list)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelContentList',
            'setVliveModelThemeColor',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.contentthemecolor = this.vliveModel.contentthemecolor
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {
        UEditor,
        VliveContentEdit,
        VliveContentImages,
        VliveContentVideos,
        VliveContentVliveImageText,
        VliveContentComment
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContent {
    width: 914px;
    .flex{
        width: 914px;
        @include flexBox(space-between);
        .theme-color{
            @include flexBox(flex-start);
            .title{
                margin-right: 10px;
            }
        }
    }
    .content-box{
        margin-top: 20px;
    }
    .el-tabs__header{
        border: 1px solid $line;
        border-bottom-width: 0;
        height: 40px;
        .el-tabs__new-tab{
            box-sizing: border-box;
            width: 100px;
            height: 40px;
            line-height: 40px;
            margin: 0;
            border-width: 0;
            border-left: 1px solid $line;
            border-bottom: 1px solid $line;
        }
    }
}
</style>
